import React, { Component } from 'react';
import './style.css';

class EditStudy extends Component {
  constructor(props){
    super(props)

    this.state={
      editText : true,
      study_url :"",
      study_name :'',
      is_live  :"",
      cpi: "",
      studyID: "",
      description:"",
    }
    this.onChange = this.onChange.bind(this);
    this.updateStudy = this.updateStudy.bind(this);
    this.edit = this.edit.bind(this);
  }

  edit(){
    this.setState({
     editText : false
  });
}

  componentDidMount() {
    
    this.setState({ studyID: this.props.editStudyData._id ,
                    study_name: this.props.editStudyData.study_name,
                    description : this.props.editStudyData.description,
                    study_url: this.props.editStudyData.study_url,
                    is_live: this.props.editStudyData.is_live,
                    cpi:  this.props.editStudyData.cpi});
  }
  
  componentWillReceiveProps(props){
      if(props.updateResponse){
        alert(props.updateResponse);
      }
      //this.setState({study_url: '',is_live:'',cpi:''});
  }

  onChange(e){
    if(e.target.name === "is_live"){
        if(e.target.value === "false"){
            this.setState({is_live: false});
        }else{
            this.setState({is_live: true});
        }
    }else{
        this.setState({[e.target.name]: e.target.value});
    } 
  
  }
  handleValidation() {
    let valid = true;
    if (this.state.study_name === "") {
		  alert("Please enter study name");
			valid = false;
		}else if (this.state.description === "") {
		  alert("Please enter description");
			valid = false;
		}else if (this.state.study_url === "") {
		  alert("Please enter study URL");
			valid = false;
		}else if (this.state.is_live === "") {
			alert("Please select is_live");
			valid = false;
		}else if (this.state.cpi === "") {
			alert("Please enter cpi");
			valid = false;
		}else if(!this.state.cpi.match(/^\d+/)){
      alert("Please only enter numeric characters");
      valid = false;
    }

		return valid;
	}

  updateStudy(){
    let studyData = {}
      if (this.handleValidation()) {
        if(this.state.study_url.includes('http')){
          studyData.study_url =  this.state.study_url;
        }else{
          studyData.study_url =  ('https://'+this.state.study_url);
        }
      studyData.studyID = this.state.studyID;
      studyData.study_name = this.state.study_name;
      studyData.description = this.state.description;
     // studyData.study_url =  ('http://'+this.state.study_url);
      studyData.is_live = this.state.is_live;
      studyData.cpi =  this.state.cpi;
      this.props.updateStudy(studyData);
      this.setState({
        editText : true
     });
    }
  }

  studyList(){
    this.props.studyList();
  }


  render() {

      let msg="";
      if(this.props.studyMessage){
        msg = this.props.studyMessage;
      }

    

      let setButton ="";
    if(this.state.editText){
        setButton = <div>
                      <div className = "stdbtn"><button  className="studySavebtn" onClick={this.edit}  >Edit</button></div><br/>
                    </div>
    }else{
        setButton = <div>
                       <div className = "stdbtn"><button  className="studySavebtn" onClick={this.updateStudy}  >Update</button></div><br/>
                    </div>
    }


    return (
      <div className = "regPage">
           <div className = "createnewstudy">
          <div className = "studyheader"><h1> Update Study</h1></div>
          <br/><button className = "editstudybackbtn" onClick={this.studyList.bind(this)}>Back</button><br/>
          <div className = "studypage">
          <label id = "lbl1">Study Name</label>
          <input type="text" className = "textFields "  name="study_name" value={this.state.study_name} onChange={this.onChange} disabled = {this.state.editText}/><br/>
          <label id = "lbl1">Study Description</label>
          <input type="text" className = "textFields "  name="description" value={this.state.description} onChange={this.onChange} disabled = {this.state.editText}/><br/>
          <label id = "lbl1">Study URL</label>
          <input type="text" className = "textFields "  name="study_url" value={this.state.study_url} onChange={this.onChange} disabled = {this.state.editText}/><br/>
          <label id = "lbl2">Is Live</label>
          <input type="radio" name="is_live" value= "true" checked={this.state.is_live === true} className="live" onChange={this.onChange} disabled = {this.state.editText} /> Yes
          <input type="radio" name="is_live" value= "false" checked={this.state.is_live === false} className="live" onChange={this.onChange} disabled = {this.state.editText} /> No <br/><br/>


          <label id = "lbl3">CPI </label>
          <input type="text" className = "textFields"   name="cpi" value={this.state.cpi} onChange={this.onChange} disabled = {this.state.editText}/><br/>

          <div>
          
         
          <div className = "stdbtn"> {setButton}</div><br/>

          </div>
          <p className = "studyMSG">{msg}</p>
     </div>
      </div>
      </div>
    );
  }
}
export default EditStudy;



// WEBPACK FOOTER //
// ./src/components/study/editStudy.js